import { render, staticRenderFns } from "./DeviceSelector.vue?vue&type=template&id=8a3874e0"
import script from "./DeviceSelector.vue?vue&type=script&lang=js"
export * from "./DeviceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports